// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"265": "56687fd82f7c692a","356": "a6b0cf008cb83be6",}[chunkId] + ".css"
}